import Cookies from 'js-cookie';

const getUsername = () => {
  const blindsCookie = Cookies.get('internalUser');

  if (!blindsCookie) {
    return undefined;
  }

  return blindsCookie.substr(0, blindsCookie.indexOf(':'));
};

export const isInternalUser = () => !!getUsername();
export const userNameWithoutDomainPrefix = () => {
  let username = getUsername();

  if (username && username.indexOf('\\') > -1) {
    const splitUsername = username.split('\\');
    username = splitUsername[splitUsername.length - 1];
  }

  return username;
};